import { FighterInfo } from '../models/fighterInfo.model';
import { SeasonFights } from '../models/seasonFights.model';

export const calculateTotalPoints = (
  fighterInfoArray: FighterInfo[],
): number => {
  return fighterInfoArray.reduce(
    (acc, fighter) => acc + (fighter.Points || 0),
    0,
  );
};

export const calculateFightsRemaining = (
  fighterInfoArray: FighterInfo[],
): number => {
  const today = new Date();
  return fighterInfoArray.filter(
    (fighter) => new Date(fighter.FightDate) > today,
  ).length;
};

export const getNextEventName = (seasonFights: SeasonFights[]): string => {
  if (seasonFights.length > 0) {
    const today = new Date();
    const upcomingEvents = seasonFights.filter(
      (fight) => new Date(fight.date) > today,
    );
    if (upcomingEvents.length > 0) {
      const nextEvent = upcomingEvents.reduce((earliest, current) => {
        return new Date(current.date) < new Date(earliest.date)
          ? current
          : earliest;
      });
      return nextEvent.event_name;
    }
  }
  return 'No upcoming events';
};
